import { SupportedBrowser } from './SupportedBrowser/SupportedBrowser';
import { UnsupportedBrowser } from './UnsupportedBrowser/UnsupportedBrowser';
import { isSupported } from 'twilio-video';

export function BrowserTest() {
  return <>{isSupported ? <SupportedBrowser /> : <UnsupportedBrowser />}</>;
}
